module.exports = __webpack_public_path__ + "static/img/landing-hero.f37a526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/landing-hero.jpg
// module id = 1754
// module chunks = 5